import { GanttNavBar } from "@/routes/_gantt/-components/GanttNavBar";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import z from "zod";

import { dateToBerlinIsoDay, isValidIsoDay } from "@workspace/datetime";

const ganttFilterSchema = z.object({
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .refine(isValidIsoDay)
    .catch(() => dateToBerlinIsoDay(new Date())),
});

export const Route = createFileRoute("/_gantt")({
  validateSearch: ganttFilterSchema,
  component: GanttLayout,
});

function GanttLayout() {
  return (
    <>
      <GanttNavBar />
      <Outlet />
    </>
  );
}
